// extracted by mini-css-extract-plugin
export default {"NotFoundPage":"NotFoundPage_NotFoundPage__ZGV7Z","dashboardBtn":"NotFoundPage_dashboardBtn__Ofgep"};